export default function mapperToCharterRequest(formData) {
    return {
      Ano: formData.year,
    };
  }